import React from "react";
import LoginForm from "../components/auth/LoginForm";
import background from "../images/LoginPageBackground.png";
import backgroundMini from "../images/LoginPageBackgroundMini.png";
import backgroundMobile from "../images/LoginPageBackgroundMobile.png";
import loginPNG from "../images/login.png"
import enjoyLogo from "../images/logo_EYB/logoEYBFull.png";
import styled from "styled-components";


const LoginPage = () => {
    return (
        <Background>
            <Login>
                <WhiteContainer>
                </WhiteContainer>
                <ContainerForm>
                    <DesktopTitle> Connexion </DesktopTitle>
                    <LoginForm/>
                </ContainerForm>
            </Login>
        </Background>
    )
}

const DesktopTitle = styled.h1`
  display: none;
  @media screen and (min-width: 900px) {
    display: initial;
    margin-top: 2em;
    margin-bottom: 2em;
    color: var(--color-purple-06);
  }
`

const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .eyb-logo-white {
    width: 20rem;
    align-self: center;
    padding-top: 1rem;
  }

  @media screen and (min-width: 900px) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    .eyb-logo-white {
      display: none;
    }
  }
`

const Login = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
  overflow: unset;
    background-image: url(${backgroundMobile});
    background-size: cover;
    background-position: top center;

  @media screen and (min-width: 900px) {
    box-shadow: 1px 1px 5px var(--color-black);
    flex-direction: row-reverse;
    align-items: stretch;
    justify-content: space-between;
    animation: popin 0.85s ease-out;
    background-image: url(${backgroundMini});
    background-size: cover;
      
  }
  @media screen and (min-width: 1200px) {
    background-image: url(${background});
    background-size: cover;
  }
`

const Title = styled.h1`
  color: var(--color-white);
  line-height: 48px;
  margin-top: 1em;
  @media screen and (min-width: 900px) {
    display: none;
  }
`
const ContainerForm = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 900px) {
    flex-direction: column;
    align-items: center;
    width: 50%;
    height: 100%;
    justify-content: center;
  }
`
const WhiteContainer = styled.div`
  height: 40%;
  width: 100%;
  display: none;
  @media screen and (min-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    order: 3;
    div {
      display: flex;
      align-items: center;
      flex-grow: 1;
    }

    .eyb-logo {
      width: 50%;
      align-self: flex-start;
      padding: 1rem;
    }

    .login-image {
      width: 350px;
    }

    height: 100%;
    width: 50%;
    border-radius: 15px 0 0 15px;
  }
  @media screen and (min-width: 1200px) {
    .login-image {
      width: 400px;
    }
  }
`

export default LoginPage